/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-row :gutter="16">
    <a-col :span="5">
      <a-card :body-style="{padding: '16px 10px'}" :bordered="false" class="cabinet">
        <station-select @select="stationSelect" />
      </a-card>
    </a-col>
    <a-col :span="19">
      <a-card :body-style="{padding: '24px', minHieght: '600px'}" :bordered="false" class="cabinet">
        <div v-if="stationId">
          <a-row :gutter="16">
            <div style="text-align: right">
              <h3 style="float: left">数据统计及排行</h3>
              <a-radio-group v-model="date" @change="onChange">
                <a-radio :value="1">
                  最近7天
                </a-radio>
                <a-radio :value="2">
                  最近30天
                </a-radio>
                <a-radio :value="3">
                  自定义
                </a-radio>
              </a-radio-group>
              <a-range-picker v-model="dateRange" valueFormat="YYYY-MM-DD" @change="dateChange" :allowClear="false"/>
            </div>
            <a-divider />
            <a-col :span="18" class="chart">
              <h4>站点派件量统计</h4>
              <v-chart :force-fit="true" :height="height" :data="dataList" :scale="scale">
                <v-tooltip />
                <v-axis />
                <v-legend />
                <v-line position="day*temperature" color="city" />
                <v-point position="day*temperature" color="city" :size="4" :v-style="style" :shape="'circle'" />
              </v-chart>
            </a-col>
            <a-col :span="6">
              <h4>投递量排行</h4>
              <a-list
                :split="false"
                size="small"
                item-layout="horizontal"
                :data-source="range"
                :indicator="partnerRangeLoading"
              >
                <a-list-item slot="renderItem" slot-scope="item,index">
                    <a-badge
                      :number-style="{
                        backgroundColor: '#314659',
                        color: '#fff',
                      }"
                      :count="index + 1" v-if="index < 3"/>
                    <a-badge
                      v-else
                      :count="index + 1"
                      :number-style="{
                        backgroundColor: '#f5f5f5',
                        color: '#333',
                      }"
                    />
                    <excom-icon :excom="item.pinyin" :text="item.name" style="margin-left: 10px; flex:1"/>
                    <span style="float: right">{{ item.num }}</span>
                </a-list-item>
              </a-list>
            </a-col>
          </a-row>
        </div>
        <a-empty v-else description="请选择站点" />
      </a-card>
    </a-col>

  </a-row>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';
import { analysisStatistic, partnerRange } from '@/api/analysis';
import DataSet from '@antv/data-set';
import moment from 'moment';

const scale = [{
  dataKey: 'day',
  min: 0,
  max: 1,
}];
export default {
  data() {
    return {
      listloading: false,
      stationId: '',
      scale,
      height: 400,
      style: { stroke: '#fff', lineWidth: 1 },
      dataList: [],
      dateRange: [],
      range: [],
    };
  },
  created() {
    this.setDefault();
  },
  methods: {
    ...mapActions(['getStationList']),
    setDefault() {
      const yesToday = moment().subtract(1, 'day').format('YYYY-MM-DD');
      const lastWeek = moment().subtract(8, 'days').format('YYYY-MM-DD');
      this.dateRange = [lastWeek, yesToday];
      this.date = 1;
    },
    dateChange() {
      this.date = 3;
      this.getList();
      this.partnerRange();
    },
    stationSelect(stationId) {
      this.stationId = stationId;
      this.getList();
      this.partnerRange();
    },
    async partnerRange() {
      this.partnerRangeLoading = true;
      const { stationId } = this;
      const [start, end] = this.dateRange;
      const { data } = await partnerRange(stationId, { start, end });
      this.range = data;
      this.partnerRangeLoading = false;
    },
    onChange() {
      const val = this.date;
      const yesToday = moment().subtract(1, 'day').format('YYYY-MM-DD');
      const lastWeek = moment().subtract(8, 'days').format('YYYY-MM-DD');
      const last30days = moment().subtract(31, 'days').format('YYYY-MM-DD');
      if (val === 1) {
        this.dateRange = [lastWeek, yesToday];
      }
      if (val === 2) {
        this.dateRange = [last30days, yesToday];
      }
      this.getList();
      this.partnerRange();
    },
    async getList() {
      this.listloading = true;
      const { stationId } = this;
      const [start, end] = this.dateRange;
      const { data } = await analysisStatistic(stationId, { start, end });
      this.setDate(data);
      this.listloading = false;
    },
    setDate(sourceData) {
      const dv = new DataSet.View().source(sourceData);
      dv.transform({
        type: 'fold',
        fields: ['pks', 'profit'],
        key: 'city',
        value: 'temperature',
      });
      const data = dv.rows;
      this.dataList = data;
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.cabinet {
  .ant-avatar{
    font-size: 20px;
  }
  &-item{
    .ant-avatar{
      background: rgba(0,0,0,.09);
    }
    &.processing{
        .ant-avatar{
          background: rgb(135, 208, 104);
        }
    }
    .warning{
      .ant-avatar{
        background: #faad14;
      }
    }
    &.error{
      .ant-avatar{
        background: #f5222d;
      }
    }
  }
}
.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
